import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, IconComponent } from '@shared/components/ui';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@ngneat/dialog';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { isMobileView } from '@core/utils';
import { CRMNewsPushNotificationEntity, CrmSurveyEntity, SurveyPushNotificationEntity } from '@core/entities';
import { TruncateTextPipe } from '@shared/pipes';
import { DefaultImageDirective } from '@shared/directives';
import { UsePushNotification } from '@core/usecases';
import { Router } from '@angular/router';
import { TippyModule } from '@ngneat/helipopper';

enum PushNotificationType {
  Survey = 'survey',
  CRMSurvey = 'crmSurvey',
  CRMNews = 'crmNews',
}

@Component({
  selector: 'app-push-notifications',
  imports: [CommonModule, ButtonComponent, IconComponent, TranslateModule, TruncateTextPipe, DefaultImageDirective, TippyModule],
  templateUrl: './push-notifications.component.html',
  styleUrls: ['./push-notifications.component.scss'],
})
export class PushNotificationsComponent implements OnInit {
  surveyPushNotifications: SurveyPushNotificationEntity[];
  crmSurveyNotifications: CrmSurveyEntity[];
  crmNewsNotifications: CRMNewsPushNotificationEntity[];
  PushNotificationType = PushNotificationType;
  private readonly _router = inject(Router);
  private readonly _dialogRef: DialogRef;
  private readonly _bottomSheetService: NgxBottomSheetService;

  private readonly _usePushNotification = new UsePushNotification();

  constructor() {
    if (isMobileView()) {
      this._bottomSheetService = inject(NgxBottomSheetService);
    } else {
      this._dialogRef = inject(DialogRef);
    }
  }

  ngOnInit() {
    if (isMobileView()) {
      this.surveyPushNotifications = this._bottomSheetService.currentSheetData.surveyNotifications;
      this.crmSurveyNotifications = this._bottomSheetService.currentSheetData.crmSurveyNotifications;
      this.crmNewsNotifications = this._bottomSheetService.currentSheetData.crmNewsNotifications;
    } else {
      this.surveyPushNotifications = this._dialogRef.data.surveyNotifications;
      this.crmSurveyNotifications = this._dialogRef.data.crmSurveyNotifications;
      this.crmNewsNotifications = this._dialogRef.data.crmNewsNotifications;
    }
  }

  closeDialog(section?: PushNotificationType | 'all', markAsRead = false) {
    if (section) {
      switch (section) {
        case PushNotificationType.Survey:
          if (markAsRead) this._markSurveysAsRead(this.surveyPushNotifications.map((item) => item.id));
          this.surveyPushNotifications = [];
          break;
        case PushNotificationType.CRMSurvey:
          if (markAsRead) this._markCrmSurveysNotificationsAsRead(this.crmSurveyNotifications.map((item) => item.id));
          this.crmSurveyNotifications = [];
          break;
        case PushNotificationType.CRMNews:
          if (markAsRead) this._markCrmNewsNotificationsAsRead(this.crmNewsNotifications.map((item) => item.newsId));
          this.crmNewsNotifications = [];
          break;
      }

      // if all arrays are empty, close the dialog
      if (
        (!this.surveyPushNotifications || !this.surveyPushNotifications.length) &&
        (!this.crmSurveyNotifications || !this.crmSurveyNotifications.length) &&
        (!this.crmNewsNotifications || !this.crmNewsNotifications.length) &&
        !markAsRead
      ) {
        this._close();
      }
    }
  }

  private _markCrmNewsNotificationsAsRead(crmNewsIds: number[]) {
    if (!crmNewsIds || !crmNewsIds.length) return;
    this._usePushNotification.readCrmNewsNotifications(crmNewsIds).subscribe();
    this._close();
    // this._close('/crm/news');
  }

  private _markCrmSurveysNotificationsAsRead(crmSurveyIds: number[]) {
    if (!crmSurveyIds || !crmSurveyIds.length) return;
    this._usePushNotification.readCrmSurveyNotifications(crmSurveyIds).subscribe();
    this._close();
    // this._close('/crm/surveys');
  }

  private _markSurveysAsRead(surveyIds: number[]) {
    if (!surveyIds || !surveyIds.length) return;
    this._usePushNotification.readLocalSurveyNotifications(surveyIds).subscribe();
    this._close('/club-tools/surveys');
  }

  private _close(data?: any) {
    if (isMobileView()) {
      this._bottomSheetService.close(data);
    } else {
      this._dialogRef.close(data);
    }
  }
}
